function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.658 11.293l.46-.46 1.54-1.54 5.54-5.54a.65.65 0 01.92 0l.494.494a.65.65 0 010 .92l-5.54 5.54L8.779 12l1.293 1.293 5.54 5.54a.65.65 0 010 .92l-.495.494a.65.65 0 01-.919 0l-5.54-5.54-1.54-1.54-.002-.002-.458-.458a1 1 0 010-1.414z",
  fill: "#81878C"
});

var SvgMobileArrow = function SvgMobileArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
};

export default SvgMobileArrow;